import { version, name } from '../../package.json'
export const SDK_NAME: string = name
export const SDK_VERSION: string = version
export const SERVER_URL = '//localhost:3000/api/error/upload'
